export default "__VITE_ASSET__167a5b61__"